var map = {
	"./avatar-02.jpg": 62569,
	"./avatar-22.jpg": 22079,
	"./avatar-36.jpg": 81600,
	"./avatar-52.jpg": 55298,
	"./profile-01.jpg": 98258,
	"./profile-02.jpg": 17213,
	"./profile-03.jpg": 91648,
	"./profile-04.jpg": 31955,
	"./profile-05.jpg": 76694,
	"./profile-06.jpg": 9953,
	"./profile-07.jpg": 31908,
	"./profile-08.jpg": 20119,
	"./profile-09.jpg": 32602,
	"./profile-10.jpg": 10864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49575;